import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import EventEmitter from '../../utils/events'

// Actions
import { getPriceModelConflicts, updatePriceModelConflicts } from '../../actions/priceModelConflict'

// Utils
import { translation } from '../../utils/helpers'

// import styles
import './conflicts.scss'

// import components
import Header from '../../shared/components/Header'
// import LeftMenu from '../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'
import { getCustomerGroups } from '../../actions/customerGroup'

// Elements
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuCustomItem from '../../shared/elements/sideMenuCustomItem'
import Text from '../../shared/elements/text'
import Check from '../../shared/elements/check'
import DropDown from '../../shared/elements/dropDown'

// Views
import View from './View'
// Utils
import { hasAccess } from '../../utils/auth'
import SideMenuItem from '../../shared/elements/sideMenuItem'

class Conflicts extends Component {
  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      search: '',
      activeItem: {},
      conflictsList: [],
      isUpdating: false,
      onlyUnsolved: true,
      customergroups: [],
      selectedcustomergroup: -1
    }
    this.onChange = this.onChange.bind(this)
    this.leftMenu = this.leftMenu.bind(this)
    this.renderView = this.renderView.bind(this)
    this.searchList = this.searchList.bind(this)
    this.filterList = this.filterList.bind(this)
    this.getConflictList = this.getConflictList.bind(this)
    this.onSave = this.onSave.bind(this)
    this.getCustomerGroups = this.getCustomerGroups.bind(this)
  }

  componentDidMount () {
    this.getConflictList()
    this.getCustomerGroups()
    // this.getCustomerGroups()
    // this.getShops()
    if (typeof this.props.router.params.customerId !== 'undefined') {
      this.setState({
        view: 'item',
        activeItem: {
          CustomerId: parseInt(this.props.router.params.customerId)
        }
      })
    }
  }

  getConflictList () {
    let workProviderId = this.props.auth.user.WorkProviderId
    this.props.getPriceModelConflicts(workProviderId).then((res) => {
      this.setState({
        conflictsList: res.data,
        activeItem: this.state.activeItem
      })
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    this.props.router.replace('/conflicts/' + activeItem.CustomerId)
  }

  searchList (e) {
    if (e.target.name === 'SearchText') {
      this.setState({
        search: e.target.value
      })
    }
    if (e.target.name === 'Unsolved') {
      this.setState({
        onlyUnsolved: e.target.checked
      })
    }
  }

  filterList (key) {
    let customerGroupIds = key.CustomerGroupIds
    let selectedGroupId = Number(this.state.selectedcustomergroup)
    if (selectedGroupId !== -1 && customerGroupIds.findIndex((val) => val === selectedGroupId) === -1) return false
    if (key.CustomerName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (this.state.onlyUnsolved ? key.HasUnsolved : true)) {
      return true
    }
    return false
  }
  getCustomerGroups () {
    if (!hasAccess([6], this.props.auth.user.UserType)) return
    this.props.getCustomerGroups().then((res) => {
      let customergroups = res.data
      this.setState({
        customergroups: customergroups
      })
    })
  }
  onChange (e) {
    let name = e.target.name
    if (name === 'customergroup_customergroupid') {
      let valu = e.target.value
      if (valu === '-1') {
        this.setState({
          selectedcustomergroup: -1
        }, () => {
          // console.log(valu, this.state)
        })
      } else {
        // let id = this.state.customergroups.find((val) => Number(val.CustomerGroupId) === Number(valu)).Name
        this.setState({
          selectedcustomergroup: valu
        }, () => {
          // console.log(valu, id, this.state)
        })
      }
    }
  }
  leftMenu () {
    // Render item
    const renderItem = (val, key) => {
      if (val === null || val.CustomerId === undefined) return
      // Classname
      let isSelected = false
      if (isEqual(val.CustomerId, this.state.activeItem.CustomerId)) {
        isSelected = true
      }

      // On select
      const selectItem = () => {
        this.setState({
          view: 'item',
          activeItem: val
        }, () => {
          this.changeView('edit')
        })
        EventEmitter.emit('sidebar_trigger', false)
      }

      // Return
      return (
        <SideMenuItem
          label={val.CustomerName}
          onClick={selectItem}
          selected={isSelected}
          key={key}
        />
      )
    }

    const renderCustomerGroups = () => {
      let customergroups = this.state.customergroups

      let renderGroup = (group, key) => (
        <option value={group.CustomerGroupId} key={key}>{group.Name}</option>
      )

      return customergroups !== null && customergroups.length > 0 && customergroups.map(renderGroup)
    }

    // Return
    return [
      <div key='filter'>
        <SideMenuCustomItem>
          <Text
            name='SearchText'
            value={this.state.search}
            onChange={this.searchList}
          />
        </SideMenuCustomItem>
        <SideMenuCustomItem>
          <DropDown
            name='customergroup_customergroupid'
            value={this.state.selectedcustomergroup}
            onChange={this.onChange}
          >
            <option value='-1'>{translation('12310')}</option>
            {renderCustomerGroups()}
          </DropDown>
        </SideMenuCustomItem>
        <SideMenuCustomItem>
          <Check
            name='Unsolved'
            checked={this.state.onlyUnsolved === true}
            onChange={this.searchList}
            labelText={translation('13029')}
            spacing={0}
          />
        </SideMenuCustomItem>
      </div>,

      ...this.state.conflictsList.filter(this.filterList).map(renderItem)
    ]
  }

  onSave (data, type) {
    let conflictsList = [...this.state.conflictsList]
    let activeItem = this.state.activeItem
    conflictsList.map((val, key) => {
      if (val.CustomerId === data.CustomerId) {
        val.CustomerName = data.CustomerName
      }
    })
    type = 'item'

    this.setState({
      conflictsList: conflictsList,
      view: type,
      activeItem: activeItem
    })
    // Toastr
    // window.toastr.success(translation('13464'), translation('13424'))
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'item':
        return <View router={this.props.router} ref='view' item={this.state.activeItem} getConflictList={this.getConflictList} onSave={this.onSave} />
    }
  }

  render () {
    return (
      <div className='priceconflicts__screen'>
        <Header router={this.props.router} title={translation('12304')} icon={'menu/Partners-White.png'} />

        <SideMenu disableFilter>
          {this.leftMenu()}
        </SideMenu>

        <LeftMenuContent className='priceconflicts__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

Conflicts.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPriceModelConflicts,
  updatePriceModelConflicts,
  getCustomerGroups,
  hasAccess
})(Conflicts)



// WEBPACK FOOTER //
// ./src/app/pages/Conflicts/index.js